import ShopBag from './ShopBag';

export default ShopBag;
